import { Component } from '@angular/core';

/** Warning icon plus the projected message, shared by the gender / name / age fields. */
@Component({
  selector: 'app-onboarding-profile-field-error',
  templateUrl: './onboarding-profile-field-error.component.html',
  host: { class: 'tw-mt-2 tw-flex' },
})
export class OnboardingProfileFieldErrorComponent {}
